import { AvatarAvailabilityDTO } from "../../types/apis/models/avatars.types";
import { fetchRefreshIntegrated, getBaseUrl } from "../api.utils";

export const getAvailableAvatarsByGroup = async (groupId: string) =>
    await fetchRefreshIntegrated<AvatarAvailabilityDTO[]>(`${await getBaseUrl("avatars")}/groups/${groupId}`);